import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/sections/Hero";
import { Story } from "./components/sections/Story";
import { Pains } from "./components/sections/Pains";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { WhyPriceGuarantee } from "./components/sections/WhyPriceGuarantee";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Author } from "./components/sections/Author";
import { Testimonials } from "./components/sections/Testimonials";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="3ikr002qv3a7b">
      <MetaPixel data-id="element-1" data-mp="3mkre1ma1tjdu" />
      <Hero data-id="element-2" data-mp="3mk85uxa7a9d0" />
      <main data-id="element-3" data-mp="3mjztd6hzp62c">
        <Story data-id="element-4" data-mp="3mjgannkimdn9" />
        <Pains data-id="element-5" data-mp="3rc9em985thya" />
        <Volumes data-id="element-6" data-mp="3rcj31sdk3h1v" />
        <Tools data-id="element-7" data-mp="3rbzq6q2rjiup" />
        <Bonuses data-id="element-8" data-mp="3rdkh85pvcjnt" />
        <Offer data-id="element-9" data-mp="3rd191gq0t9mz" />
        <WhyPriceGuarantee data-id="element-10" data-mp="3relvej26lm9r" />
        <BeforeAfter data-id="element-11" data-mp="6hp9c27i9cj" />
        <Author data-id="element-12" data-mp="4wyzymxdckh" />
        <Testimonials data-id="element-13" data-mp="5ggxfcks0yi" />
        <FAQ data-id="element-14" data-mp="7suzhf7pr6a" />
        <FinalCTA data-id="element-15" data-mp="2zl3cxocsjc6w" />
      </main>
      <Footer data-id="element-16" data-mp="2zm4yimrfnh2v" />
      <FloatingCTA data-id="element-17" data-mp="2zmemk4sx3e5x" />
      <PurchasePopup data-id="element-18" data-mp="2zn69yscd25l4" />
    </div>;
}